export default __webpack_public_path__ + "static/media/ic_person_grey.4732ef68.svg";